/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>cui-singular-setting.component.ts</name>
///
/// <description>

/// </description>
///
/// <author>Michael Martinez</author>
/// <created>14 Oct 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 14Oct16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import {Component, OnInit, Input, Output, SimpleChanges, ViewEncapsulation, EventEmitter } from '@angular/core';
 

import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';

import {ActivatedRoute, Params } from '@angular/router';
import {Subscription} from 'rxjs/Subscription';  
import { MenuItem, Message } from 'primeng/primeng';
  
import {CUIFeatureInterface} from  '../../interfaces/cui-feature.interface'; 

import {TranslatedStringsService } from '../../services/language.service';
import {DeviceControlType } from  '../../models/device-data-models/device-control-type.model';
import {DeviceControlActionType } from   '../../models/device-data-models/device-control-action-type.model';

import {DeviceControlEventModel } from  '../../models/device-data-models/device-control-event.model';
import {DeviceFormControlModel  } from  '../../models/device-data-models/device-form-control.model';
import {DeviceControlModel } from  '../../models/device-data-models/device-control.model';
import {DeviceCategoryModel } from  '../../models/device-data-models/device-category.model';
import {DeviceCategoryCollectionModel } from  '../../models/device-data-models/device-category-collection.model'; 



@Component({
    selector: 'cui-singular-setting',
    template: '' 
})
export class CUISingularSettingComponent implements CUIFeatureInterface {
     
 
    @Input() model: DeviceControlModel; 
    @Input() formSettings: any;   
    @Input() selectiveMode: boolean;    

    @Output() onSettingEvent = new EventEmitter(); 
    
    protected DeviceControlType:typeof DeviceControlType = DeviceControlType;//MM - Needed to allow enum in Template

    protected uploadedFiles: any[] = [];    
    protected uploadMsgs: Message[]; 
    protected selectable: boolean = true;
    protected settingSelected: boolean = false;
    protected lblSavedAsGroupSetting: string = "";
    protected lblInheritedFromGroupSetting: string = "";
    protected lblIsConflicted: string = "";
    protected lblPendingSetting: string = "";
    protected lblInheritedPendingSetting: string = "";
    protected lblUnsupportedSetting: string = "";
    protected lblInheritedUnsupportedSetting: string= "";

    protected lblOK: string = "";
    protected lblCancel: string = "";
    protected formChangesSubscription: Subscription;
    protected lblIsInvalid:string = ""
    constructor(protected i18n: TranslatedStringsService,
                protected formBuilder: FormBuilder 
       
    ) { 
      

         

        

    } 

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------
     ngOnChanges(changes: any) {

        if (this.model) {
            this.lblIsInvalid = this.model.label + " " + this.i18n.translate("is-invalid");
            this.lblSavedAsGroupSetting = this.model.label + " " + this.i18n.translate("saved-as-group-setting");
        }

    }     


    ngDoCheck() { } 
    ngAfterContentInit() { }
    ngAfterContentChecked() { }
    ngAfterViewInit() {   }
    ngAfterViewChecked() { };

    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

 		//this.i18n.init().then((response) => {
            this.translate();
        //});
        

    }

    //----------------------------------------------------------
    //ngOnDestroy
    //----------------------------------------------------------
    ngOnDestroy() {
        this.stopFormChangesSubscription();
    }

    //----------------------------------------------------------
    //translate
    //----------------------------------------------------------
    protected translate() {
          this.lblInheritedFromGroupSetting = this.i18n.translate("inherited-from-group-setting");
            //this.lblSavedAsGroupSetting = this.i18n.translate("saved-as-group-setting");
            this.lblOK = this.i18n.translate("ok-button-label");
            this.lblCancel = this.i18n.translate("cancel-button-label");
            //this.lblIsInvalid = this.model.label + " " + this.i18n.translate("is-invalid");
            this.lblIsConflicted = this.i18n.translate("is-conflicted");
            this.lblPendingSetting = this.i18n.translate("pending-setting");
            this.lblInheritedPendingSetting = this.i18n.translate("inherited-pending-setting");
            this.lblUnsupportedSetting = this.i18n.translate("unsupported-setting");
            this.lblInheritedUnsupportedSetting = this.i18n.translate("inherited-unsupported-setting");
    }

      //----------------------------------------------------------
      //hideSelector
      //----------------------------------------------------------
    protected hideSelector() {
         return !this.model.policy || this.model.locked ||   this.model.inherited;

      }
   

     //-----------------------------------------------
    // labelCSS
    //-----------------------------------------------
    protected labelCSS() {
 
         //let labelClass:string = (this.model.conflicted) ? "ui-outputlabel setting-conflicted" : "ui-outputlabel";
         return "ui-outputlabel";//labelClass;

     }

   
    //-----------------------------------------------
    // stopFormChangesSubscription
    //-----------------------------------------------
    protected stopFormChangesSubscription() {

        if (this.formChangesSubscription)
            this.formChangesSubscription.unsubscribe();
    } 
    //----------------------------------------------------------
    //labelTooltip
    //----------------------------------------------------------
    protected labelTooltip() { 
          return "";//(this.model.conflicted) ? this.model.label + " " + this.i18n.translate("setting-conflict") : ""; 
    }

    //----------------------------------------------------------
    //toolTipText
    //----------------------------------------------------------
    protected  toolTipText() {
          return (this.hideSelector()) ? "" : this.i18n.translate("include-as-group-setting"); 
    }

     //----------------------------------------------------------
    //labelColor
    //----------------------------------------------------------
    protected labelColor() {

        let out: string;

        if (this.model.policy) {
            out = (this.model.conflicted) ? 'Red' : '' 
        }
        else {
            out = '';
        }

        return out;

    }

    //----------------------------------------------------------
    //defaultDate()
    //----------------------------------------------------------
    protected defaultDate() {
 
        return new Date();

    }

    //----------------------------------------------------------
    //isSettingDisabled()
    //----------------------------------------------------------
    protected isSettingDisabled() {  

        let bFlag: boolean = false;

        if (this.model ) {
            if (!this.model.apply || this.model.inherited) {
                bFlag = true;
            }
        }
        return bFlag;

    }

    //----------------------------------------------------------
    //isIncluded
    //----------------------------------------------------------
    protected isIncluded() {

        return this.model.policy && this.model.apply && !this.model.inherited && !this.model.conflicted && !this.isInvalid()  ;

    }

    //----------------------------------------------------------
    //isInvalid
    //----------------------------------------------------------
    protected isInvalid() {

        return !this.formSettings.controls[this.model.id].valid && this.model.apply && !this.model.inherited;

    }

    //----------------------------------------------------------
    //isInherited
    //----------------------------------------------------------
    protected isInherited() {

        return this.model.inherited;

    }

    //----------------------------------------------------------
    //isUnsupported
    //----------------------------------------------------------
    protected isUnsupported() {

        return this.model.unsupported;

    }

    //----------------------------------------------------------
    //isConflicted
    //----------------------------------------------------------
    protected isConflicted() {

        return this.model.policy && this.model.apply && !this.model.inherited && this.model.conflicted && !this.isInvalid();

    }

    //----------------------------------------------------------
    //isPending
    //----------------------------------------------------------
    protected isPending() {

        return this.model.pending;

    }
   
    //----------------------------------------------------------
    //selectorText
    //----------------------------------------------------------
    protected selectorText() {   
        
        return (this.hideSelector()) ? "" : (this.model.apply) ? this.i18n.translate("exclude-group-setting") : this.i18n.translate("include-group-setting");

    }

    //----------------------------------------------------------
    //isSelectable
    //----------------------------------------------------------
    protected isSelectable() {


        return ((this.model.policy) && this.model.selectable);

    }
  
    //----------------------------------------------------------
    //onUpload
    //----------------------------------------------------------
    protected onUpload(event) {

        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }

        this.uploadMsgs = [];
        this.uploadMsgs.push({ severity: 'info', summary: 'File Uploaded', detail: '' });
    }
     //----------------------------------------------------------
    //onAddClick
    //----------------------------------------------------------
    protected onAddClick(event: DeviceControlEventModel, id:string) {

        event.action = DeviceControlActionType.Add;
        this.onSettingEvent.emit(event );
        
    }
     //----------------------------------------------------------
    //onEditClick
    //----------------------------------------------------------
    protected onEditClick(event: DeviceControlEventModel, id: string) {

        event.action = DeviceControlActionType.Edit;
        this.onSettingEvent.emit(event);

    }

     //----------------------------------------------------------
    //onRemoveClick
    //----------------------------------------------------------
    protected onRemoveClick(event: DeviceControlEventModel, id: string) {
        event.action = DeviceControlActionType.Remove;
        this.onSettingEvent.emit(event);

    }
   //----------------------------------------------------------
    //onClick
    //----------------------------------------------------------
    protected onClick(event: DeviceControlEventModel) {
        this.onChange(event); 
    }

    //----------------------------------------------------------
    //onRemoveClickonChange
    //----------------------------------------------------------
    protected onChange(event: DeviceControlEventModel) {

         
        let control: any = this.formSettings.controls[this.model.id];

        this.onSettingEvent.emit(event);

        if (this.isSettingDisabled()) {
            control.disable();  
        }
        else {
            control.enable(); 
        }


    }
    protected onBlur(event: DeviceControlEventModel) {
        this.onSettingEvent.emit(event);
    }
    protected onFocus(event: DeviceControlEventModel) {
        this.onSettingEvent.emit(event);
    }
    protected onKey(event: DeviceControlEventModel) {
        this.onSettingEvent.emit(event);
    } 
    protected onMouse(event: DeviceControlEventModel) {
        this.onSettingEvent.emit(event);
    }

    //Add
    protected onAddOK(event: DeviceControlEventModel, id: string) { 
        //this.model.visible = false;
        event.action = DeviceControlActionType.OK;
        this.onSettingEvent.emit(event);
    }

    protected  onAddCancel(event: DeviceControlEventModel, id: string) { 
      //  this.model.visible = false;
        event.action = DeviceControlActionType.Cancel;
        this.onSettingEvent.emit(event);
    }
    //Edit
    protected onEditOK(event: DeviceControlEventModel, id: string) {
      //  this.model.visible = false;
        event.action = DeviceControlActionType.OK;
        this.onSettingEvent.emit(event);
    }

    protected onEditCancel(event: DeviceControlEventModel, id: string) {
       // this.model.visible = false;
        event.action = DeviceControlActionType.Cancel;
        this.onSettingEvent.emit(event);
    }
    //Remove
    protected onRemoveOK(event: DeviceControlEventModel, id: string) {
       // this.model.visible = false;
        event.action = DeviceControlActionType.OK;
        this.onSettingEvent.emit(event);
    }

    protected onRemoveCancel(event: DeviceControlEventModel, id: string) {
        //this.model.visible = false;
        event.action = DeviceControlActionType.Cancel;
        this.onSettingEvent.emit(event);
    }



    protected crudIcon(label) {
        let out = "fa-external-link-square";
        switch (label) {

            case "add":
                out = "fa-plus";
                break;
            case "edit":
                out = "fa-pencil";
                break;
            case "remove":
                out = "fa-times";
                break;
        }
        return out;
    }
}

     
     



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-singular-setting/cui-singular-setting.component.ts